import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	container: {
		padding: 24,
		width: 600,
		maxWidth: '90vw',
		maxHeight: '80vh',
		display: 'flex',
		flexDirection: 'column',
	},
	header: {
		marginBottom: 20,
	},
	title: {
		fontSize: 20,
		fontWeight: 600,
		color: '#1f2937',
		margin: 0,
		marginBottom: 8,
	},
	description: {
		fontSize: 14,
		color: '#6b7280',
		margin: 0,
	},
	filterContainer: {
		display: 'flex',
		flexWrap: 'wrap',
		gap: 8,
		marginBottom: 20,
	},
	filterButton: {
		padding: '6px 14px',
		fontSize: 13,
		fontWeight: 500,
		backgroundColor: '#f3f4f6',
		color: '#6b7280',
		border: 'none',
		borderRadius: 6,
		cursor: 'pointer',
		transition: 'all 0.15s ease',
		':hover': {
			backgroundColor: '#e5e7eb',
			color: '#374151',
		},
	},
	filterButtonActive: {
		backgroundColor: '#6366f1',
		color: '#ffffff',
		':hover': {
			backgroundColor: '#4f46e5',
			color: '#ffffff',
		},
	},
	grid: {
		display: 'grid',
		gridTemplateColumns: 'repeat(2, 1fr)',
		gap: 12,
		overflowY: 'auto',
		flex: 1,
		paddingRight: 4,
	},
	stepCard: {
		padding: 16,
		borderRadius: 10,
		border: '2px solid',
		cursor: 'pointer',
		textAlign: 'left',
		transition: 'all 0.2s ease',
		':hover': {
			transform: 'translateY(-2px)',
			boxShadow: '0 6px 16px rgba(0, 0, 0, 0.12)',
		},
		':focus': {
			outline: '2px solid #6366f1',
			outlineOffset: 2,
		},
		':active': {
			transform: 'translateY(0)',
		},
	},
	stepHeader: {
		display: 'flex',
		alignItems: 'center',
		gap: 10,
		marginBottom: 6,
	},
	stepLabel: {
		fontSize: 15,
		fontWeight: 600,
		color: '#1f2937',
	},
	stepDescription: {
		fontSize: 13,
		color: '#6b7280',
		marginLeft: 26,
		lineHeight: 1.4,
	},
	actions: {
		display: 'flex',
		justifyContent: 'flex-end',
		paddingTop: 20,
		borderTop: '1px solid #e5e7eb',
		marginTop: 20,
	},
	cancelButton: {
		padding: '10px 20px',
		borderRadius: 6,
		fontSize: 14,
		fontWeight: 500,
		backgroundColor: '#f3f4f6',
		color: '#374151',
		border: 'none',
		cursor: 'pointer',
		transition: 'all 0.2s ease',
		':hover': {
			backgroundColor: '#e5e7eb',
		},
	},
});
